import React from 'react';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import CheckIcon from '@mui/icons-material/Check';
import ViolationTooltip from 'components/PerformanceReview4c/ViolationTooltip';
import ProctorshipDialog from './ProctorshipDialog';
import makeStyles from '@mui/styles/makeStyles';

import { Box, Typography, Tooltip } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  container: {
    height: 140,
    width: 140,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  backgroundBox: {
    width: 48,
    height: 39,
    backgroundColor: theme.palette.primary['clr-100'],
    borderRadius: theme.spacing(1),
    position: 'absolute',
  },
  innerBox: {
    width: '132px',
    height: '132px',
    backgroundColor: theme.palette.shades['clr-white-900'],
    zIndex: 2,
    boxShadow: `
      0px 4px 4px 0px #CCD4DE1A,
      0px 10px 20px 0px #CCD4DE4D,
      0px 7px 28px 0px #CCD4DE33
    `,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    justifyContent: 'center',
    alignItems: 'center',
  },
  proctorCircle: {
    width: '68px',
    height: '68px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'box-shadow 0.2s ease-in-out',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  proctorRed: {
    backgroundColor: theme.palette.danger['clr-500'],
    boxShadow: `
      0px 4px 4px 0px #E2483C1A,
      0px 5px 12px 0px #E2483C4D,
      0px 7px 32px 0px #CCD4DEE5
    `,
  },
  proctorGreen: {
    backgroundColor: theme.palette.success['clr-500'],
    boxShadow: `
      0px 4px 4px 0px #0099701A,
      0px 5px 12px 0px #0099704D,
      0px 7px 32px 0px #CCD4DEE5
    `,
  }
}));

const cornerPositions = [
  { top: 0, left: 0 },
  { top: 0, right: 0 },
  { bottom: 0, left: 0 },
  { bottom: 0, right: 0 },
];

const Proctorship = ({ records = [] }) => {
  const classes = useStyles();

  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [violated, setVoilated] = React.useState(false);

  React.useEffect(() => {
    const voilations = records.filter((record) =>
      ['MOVE_AWAY', 'TAB_SWITCH', 'CAMERA_DISABLED', 'EXIT_FULL_SCREEN'].includes(record.type)
    );

    setVoilated(!!voilations.length);
  }, [records]);

  return (

    <Box className={classes.container}>
      {cornerPositions.map((pos, idx) => (
        <Box key={idx} className={classes.backgroundBox} sx={pos} />
      ))}

      <Box className={classes.innerBox}>
        <Typography variant="body01-bold" color="neutral.clr-900">
          Proctorship
        </Typography>
        <Tooltip
          placement="bottom"
          title={<ViolationTooltip violated={violated} setIsDialogOpen={setIsDialogOpen} />}
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: 'transparent',
                p: 0,
              },
            },
          }}
        >
          <Box
            className={`${classes.proctorCircle} ${violated ? classes.proctorRed : classes.proctorGreen}`}
          >
            {violated ? (
              <PriorityHighIcon sx={{ color: '#fff' }} />
            ) : (
              <CheckIcon sx={{ color: '#fff' }} />
            )}
          </Box>
        </Tooltip>
      </Box>

      <ProctorshipDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        violated={violated}
        records={records}
      />
    </Box>
  );
};

export default Proctorship;
